'use client'

import {
  shouldTrackOncePerSessionDay,
  useAbTest,
  useTrackAbTest,
} from '@marketplace-web/feature-flags/ab-tests-data'
import { SessionTrackWebVitals } from '@marketplace-web/layout/legacy-layout-feature'

const WebpImageTracker = () => {
  const abTest = useAbTest('web_webp_images')
  useTrackAbTest(abTest, shouldTrackOncePerSessionDay)

  if (!abTest) return null

  return (
    <SessionTrackWebVitals
      prefix="webp_"
      labels={{ webp_images: abTest.variant }}
      disableSystemTimingEvent
    />
  )
}

export default WebpImageTracker
